/**
 * La promocion que no se aplica a dedo: al pulsarla se abre PromoCodeModal
 * para canjear un codigo. Se compara por este literal en varios sitios.
 */
export const CODE_PROMO = 'CÓDIGO DESCUENTO';

export const PROMO_CODES = [
    { code: 'CÓDIGO DESCUENTO', label: 'Código Descuento (12%)', discountPercent: 12 },
    { code: 'VUELTA AL COLE', label: 'Vuelta al Cole (10%)', discountPercent: 10 },
    { code: 'BIENVENIDO', label: 'Bienvenido (5%)', discountPercent: 5 },
    { code: 'GRAN LECTOR', label: 'Gran Lector (15%)', discountPercent: 15 },
    { code: 'CLUB LIBRO', label: 'Club Libro (20%)', discountPercent: 20 },
    { code: 'DÍA DEL LIBRO', label: 'Día del Libro (10%)', discountPercent: 10 },
    { code: 'LECTOR VIP', label: 'Lector VIP (25%)', discountPercent: 25 },
];

/**
 * Codigos que el cajero puede canjear desde PromoCodeModal al pulsar
 * "Codigo Descuento". El backend no los valida todavia: la comprobacion es
 * local, igual que en el TPV de referencia (tpv-albatross-4).
 */
export const REDEEMABLE_CODES = [
    { code: 'PONS12', discountPercent: 12, description: 'Descuento Marcial Pons (12%)' },
    { code: 'MARCIAL12', discountPercent: 12, description: 'Descuento General Marcial (12%)' },
    { code: 'LECTOR12', discountPercent: 12, description: 'Descuento Lector de Honor (12%)' },
    { code: 'DESCUENTO12', discountPercent: 12, description: 'Descuento Promocional (12%)' },
    { code: '1212', discountPercent: 12, description: 'Campaña Numérica POS (12%)' },
    { code: '1010', discountPercent: 10, description: 'Campaña Numérica Diez (10%)' }
];